<template>
<!-- 处方 -->
  <div class="presciptionWrapper" v-if="showData.drug_type !=5">
    <div class="presciption">
      <div class="header">{{ showData.recipeType }}</div>
      <div class="prescStamp">
        <h3 class="prescStampTitle">银川零氪互联网医院 处方笺</h3>
        <img src="../assets/images/hospital.png" class="stamp">
      </div>
      <div class="spline"></div>
      <div class="patientInfo">
        <div class="basicInfo">
          <p>
            <span>费别：</span><span>{{showData.type}}</span>
            <!-- <span class="basicItem"> 医疗证/医保卡号：</span><span>{{ showData.medicareCard }}</span> -->
          </p>
          <p>
            <span>姓名：</span><span>{{showData.name?(showData.name.length> 5? showData.name.slice(0, 5) + '...' : showData.name):''}}</span>
            <span class="basicItem"> 性别：</span><span>{{ showData.sex }}</span>
            <span class="basicItem">年龄：</span><span>{{showData.age?showData.age:''}}岁</span>
          </p>
          <p>
            <span>科室：</span><span>{{showData.deptName || showData.doctorInfo.deptName}}</span>
            <span class="basicItem"> 处方编号：</span><span>{{ showData.recipeCode }}</span>
          </p>
        </div>
        <p>
          <span class="widthAllergies">过敏史：</span><span class="extendInfo">{{showData.allergies}}</span>
        </p>
        <p><span class="widthAllergies">诊断：</span><span class="extendInfo">{{showData.diagnoseStr}}</span></p>
      </div>
      <div class="spline"></div>
      <div class="drugInfos">
        <h3 class="drug-info-flag">Rp:</h3>
        <div v-if="showData.drug_type === '1'">
          <div  class="drugItem">
            <div v-for="(item,index) in showData.drugList" :key="index" class="drugItemRaw">
              <span>·{{ item.drugName }} （{{ item.usage }}）</span><span class="ml10" v-if="showData.useStatus==2 || showData.useStatus==3">{{ item.actualSpecification }}</span>
            </div>
          </div>
          <p class="usage">
            <span class="usageTitle">用法用量：</span>
            <span class="usageInfo">{{showData.dosage}}</span>
          </p>
        </div>
        <div class="drugBox" v-else v-for="(item, index) of showData.drugList" :key="index">
          <p class="usage drugLine">
            <span class="usageTitle">药品：</span>
            <span class="usageInfo">
              {{item.drugName}}
              <br>
              {{item.actualSpecification}}
            </span>
          </p>
          <p class="usage drugLine">
            <span class="usageTitle">用法用量：</span>
            <span class="usageInfo">{{item.usage}} {{item.medication_time}}</span>
          </p>
          <p class="usage drugLine">
            <span class="usageTitle">补充说明：</span>
            <span class="usageInfo">{{item.other}}</span>
          </p>
        </div>
      </div>
      <div class="blank">以下空白</div>
      <div class="spline"></div>
      <div class="doctorInfos">
        <p>
          医师：<span class="doctorName">{{showData.creatorName}}</span> 药费： {{showData.totalPrice}}元<br>
          <span class="doctorType">审核：</span><span class="doctorName">{{showData.auditorName}}</span>
          <span class="doctorType ml5">复核：</span><span class="doctorName">{{showData.checkName}}</span>
          <span class="doctorType ml5">调配：</span><span class="doctorName">{{showData.operateName}}</span>
        </p>
        <p>日期：<span class="doctorName">{{showData.validTerm}}</span></p>
      </div>
      <div class="remark">
        药师提示：鉴于药物都有一定副作用，请您在服药前仔细阅读说明书，了解禁忌及慎用情况！<br>注：处方1日内有效。
      </div>
    
    </div>
  </div>
</template>

<script>
export default {
  name: 'prescription',
  props: ['showData'],
};
</script>

<style scoped lang='less'>
.presciptionWrapper {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #bbb;
}
.presciptionWrapper:last-child {
  border: none;
}

.presciption {
  position: relative;
  width: 100%;
  background: #ffffff;
  padding: 0px 15px 0px 15px;
  margin-top: 10px;
  text-align: left;
  .header {
    // position: fixed;
    position: absolute;
    top: 12px;
    right: 20px;
  }
  .prescID {
    padding: 10px 0px 5px 15px;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    color: #999999;
  }

  .prescStamp {
    position: relative;
    text-align: center;
    vertical-align: middle;
    padding-top: 45px;
    padding-bottom: 55px;
    margin: 4px 0 0 0;

    .stamp {
      border-radius: 50%;
      width: 106px;
      height: 106px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -50px;
      margin-top: -55px;
    }
  }

  .patientInfo {
    margin-bottom: 12px;
    font-family: PingFangSC-Regular;
    color: #333333;
    line-height: 21px;
    font-size: 13px;

    p {
      display: flex;
    }

    .basicInfo {
      white-space: nowrap;/*设置不换行*/
      .basicItem {
        // min-width: 60px;
        padding-left: 35px;
      }
    }
    .widthAllergies {
      width: 55px;
    }
    .left {
      width: 40px;
    }

    .extendInfo {
      word-wrap: break-word;
      word-break: normal;
      flex: 1;
    }
  }

  .drugInfos {
    background: #ffffff;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #000000;
    line-height: 42px;

    p {
      line-height: 20px;
      word-wrap: break-word;
      word-break: normal;
      margin-bottom: 5px;
    }
    .drug-title-box {
      padding-left: 15px;
      font-weight: bold;
    }

    .drugItem {
      margin-top: 8px;
      padding-bottom: 10px;
      display: flex;
      flex-wrap: wrap;
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #333333;
      letter-spacing: 0.32px;
      line-height: 18px;
    }
    .drugItemRaw {
      width: 50%;
      .ml10 {
        margin-left: 10px;
      }
    }
    .usage {
      display: flex;
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #333333;
      letter-spacing: 0.32px;
      line-height: 18px;
    }
    .usageTitle {
      width: 70px;
      overflow: hidden;
    }
    .usageInfo {
      flex: 1;
    }
    .drugLine {
      margin: 8px 0;
    }
    .drugBox {
      margin-top: 32px;
    }
  }

  .doctorInfos {
    background: #ffffff;
    width: 100%;
    bottom: 5%;
    font-size: 13px;
    color: #000000;

    p {
      line-height: 18px;
      word-wrap: break-word;
      word-break: normal;
    }

    .doctorType {
      font-family: PingFangSC-Regular;
    }
    .ml5 {
      margin-left: 5px;
    }

    .doctorName {
      font-family: Jyinbixinsu;
    }

    .doctorStamp {
      padding: 1px 5px 1px 5px;
      border: 1px solid #ff3b3b;
      border-radius: 4px;
      color: #ff3b3b;
      margin-left: 10px;
    }
  }
  .spline {
    height: 1px;
    background: rgba(0,0,0,0.10);
    margin-bottom: 12px;
  }
  .blank {
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #CCCCCC;
    letter-spacing: 0.32px;
    text-align: center;
    line-height: 18px;
    margin-top: 5px;
    margin-bottom: 12px;
  }

  .drug-info-flag {
    font-family: SFProText-Medium;
    font-size: 17px;
    color: #333333;
    letter-spacing: -0.41px;
    line-height: 22px;
  }
}
.remark {
  font-family: SFProText-Regular;
  font-size: 13px;
  color: rgba(0,0,0,0.38);
  letter-spacing: 0.35px;
  line-height: 18px;
  background:rgba(255,255,255,0.00);
  padding: 12px 0;
}
 
</style>
